import styled from '@emotion/styled';
import { Sender } from '../IndividualChatBodyNew';
import { Colors } from 'styles/variables/colors';
import { css } from '@emotion/react';

export const DeleteMessageContainer = styled.div<{ show: boolean }>`
    margin-top: 14px;
    margin-left: 3px;
    cursor: pointer;
    display: ${({ show }) => (show ? 'block' : 'none')};
`;
interface StyledMessageItemProps {
    sender: Sender;
    deleted?: boolean;
}

export const StyledMessageItemDate = styled.div`
    font-family: Montserrat, sans-serif;
    justify-content: center;
    font-style: normal;
    line-height: 15px;
    font-weight: 700;
    margin-top: 18px;
    font-size: 12px;
    color: #282828;
    display: flex;
`;

export const StyledMessageAvatar = styled.img`
    border-radius: 50%;
    object-fit: cover;
    height: 40px;
    width: 40px;
    margin-top: 10px;
    min-height: 40px;
    min-width: 40px;
`;
export const StyledMessageItem = styled.div<StyledMessageItemProps>`
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    margin-left: 20px;
    margin-top: 20px;
    max-width: 70%;
    display: flex;

    &:last-of-type {
        margin-bottom: 20px;
    }

    ${(props) =>
        props.sender === Sender.ME &&
        `
            flex-direction: row-reverse;
            align-self: flex-end;
            margin-right: 20px;
        `}

    ${(props) =>
        props.sender === Sender.ADMIN &&
        `
            display: none;
        `}
`;

export const StyledMessageBubble = styled.div<StyledMessageItemProps>`
    box-sizing: border-box;
    margin: 0 12px 0 20px;
    background: ${({ deleted }) => (deleted ? Colors.lightGray : '#f3a712')};
    border-radius: 4px;
    padding: 16px 20px;
    color: #ffffff;
    ${({ deleted }) =>
        deleted &&
        css`
            opacity: 0.8;
        `}

    ${({ sender, deleted }) =>
        sender !== Sender.ME &&
        css`
            background: ${deleted ? Colors.lightGray : '#8925FF'};
        `}
`;

export const StyledMessageTime = styled.div`
    box-sizing: border-box;
    margin-top: 16px;
`;

export const StyledStatusesContainer = styled.div`
    flex-direction: column;
    position: relative;
    margin-top: 20px;
    display: flex;

    & svg:nth-of-type(2) {
        position: absolute;
        top: 5px;
    }
`;

export const StyledReferenceLink = styled.span`
    color: #8353e2;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;

export const StyledMessageAuthor = styled.div<StyledMessageItemProps>`
    font-family: Montserrat, sans-serif;
    color: #6e6e6e; // A lighter color for less emphasis
    font-size: 14px; // Slightly smaller than the message font size
    font-weight: 500; // Lighter weight for differentiation
    margin: 0 0 5px 20px; // Adjust margin as needed
    align-self: flex-start; // Align to the start of the flex container

    ${(props) =>
        props.sender === Sender.ME &&
        `
            align-self: flex-end; // Align right for messages from 'ME'
            margin: 0 20px 5px 0; // Adjust margin for right alignment
        `}
`;
